// 系统页面
const sysPages = [
  {
    path: "/districtManage",
    name: "DistrictManage",
    component: () => import("@/views/sys/District"),
    meta: { menuName: "系统地区管理" }
  },
  {
    path: "/industryManage",
    name: "IndustryManage",
    component: () => import("@/views/sys/Industry"),
    meta: { menuName: "系统行业管理" }
  },
  {
    path: "/dictCodeManage",
    name: "DictCodeManage",
    component: () => import("@/views/sys/DictCode"),
    meta: { menuName: "系统字典项管理" }
  },
  {
    path: "/dictCodeTypeManage",
    name: "DictCodeTypeManage",
    component: () => import("@/views/sys/DictCodeType"),
    meta: { menuName: "系统字典类型管理" }
  },
];

export default sysPages;